import React from 'react';
import { css } from '@emotion/react';

import WizardOption from './WizardOption'
import theme from "../../theme";

type Stage = {
    stage: string,
    title: string,
    link?: string,
};

type Props = {
    stages: Array<Stage>,
    activeStage: string,
};

const WizardPanel: React.FC<Props> = ({stages, activeStage}) => {
    const currentIndex = stages.findIndex((value) => value.stage === activeStage);
    const currentIsLast = currentIndex === stages.length - 1;

    return (
        <div css={containerStyle}>
            <div css={wizardPanel(currentIsLast)}>
                {stages.map((stage, index) => (
                    <React.Fragment key={stage.title}>
                        <WizardOption
                            progress={getOptionProgress(index, currentIndex)}
                            stageNumber={index + 1}
                            stageText={stage.title}
                            link={stage.link}
                            totalLength={stages.length}
                            isCurrent={stage.stage === activeStage}
                        />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

const getOptionProgress = (index: number, currentIndex: number): string => {
    if (index < currentIndex) return 'done';
    if (index === currentIndex) return 'doing';
    return 'todo';
};

const containerStyle = css`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
`;

const wizardPanel = (currentIsLast: boolean) => css`
    position: relative;
    display: flex;
    margin-top: 17px;
    width: 100%;
    height: 36px;
    border-radius: 16px;
    background-color: white;
    
    ${theme.breakpoints.only("md")} {
        min-width: 522px;
    }

    ${theme.breakpoints.only("sm")} {
        min-width: 507px;
    }

    ${theme.breakpoints.down("xs")} {
        min-width: 328px;
    }
`;

export default WizardPanel;
